export default __webpack_public_path__ + "static/media/opinion_top.e6d341a5.svg";